import { makeStyles, useTheme } from '@material-ui/core/styles';

import { SHOWROOM_LAYOUT_HEADER_HEIGHT } from 'components/Showroom/Layout/styles';

import { secondaryColor } from 'Styles/theme';

export const Theme = useTheme;

export const HEADER_HEIGHT = 100;
export const MOBILE_HEADER_HEIGHT = 50;

export const useStyles = makeStyles(theme => {
	return {
		showroomAppBar: {
			background: 'white',
			padding: 0,
			left: 0
		},
		showroomHeader: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'center',
			height: HEADER_HEIGHT,
			padding: '0 50px',
			background: 'white'
		},
		showroomHeaderPreviewScroll: {
			width: 'calc(100% - 15px)'
		},
		showroomHeaderMobile: {
			minHeight: 0,
			height: MOBILE_HEADER_HEIGHT,
			padding: '0px 20px',
			boxShadow: theme.custom.defaultBoxShadow
		},
		showroomHeaderPreviewView: {
			top: SHOWROOM_LAYOUT_HEADER_HEIGHT
		},
		showroomLogo: {
			maxWidth: 500,
			width: '80%',
			backgroundPosition: 'center center',
			height: '77%',
			backgroundSize: 'contain',
			backgroundRepeat: 'no-repeat'
		},
		showroomLogoMobile: {
			maxWidth: 250,
			height: '80%'
		},
		showroomLogoMobileLeftAlign: {
			backgroundPosition: 'left center'
		},
		boxShadowHeader: {
			boxShadow: theme.custom.defaultBoxShadow
		},
		headerLeftSection: {
			flex: 1
		},
		headerLeftSectionEmpty: {
			flex: 0
		},
		actionsContainer: {
			display: 'flex',
			flex: 1,
			alignSelf: 'stretch',
			alignItems: 'stretch',
			justifyContent: 'flex-end'
		},
		actionButton: {
			padding: 0,
			width: 125,
			borderRadius: 0,
			position: 'relative',

			'&:after': {
				content: '""',
				position: 'absolute',
				bottom: 0,
				width: '100%'
			},

			'&:hover': {
				backgroundColor: 'transparent',
				'&:after': {
					borderBottom: `5px solid #4df7b940`
				}
			}
		},
		actionButtonMobile: {
			width: 'auto'
		},
		selectedButton: {
			'&:after': {
				borderBottom: `5px solid ${secondaryColor} !important`
			}
		},
		tabContainer: {
			height: `calc(100vh - ${HEADER_HEIGHT}px)`,
			background: 'black',
			color: 'white',
			overflowY: 'auto'
		},
		tabContainerMobile: {
			height: `calc(100vh - ${MOBILE_HEADER_HEIGHT}px)`
		},
		basketBadge: {
			width: 30,
			fontWeight: 'bold',
			top: 10,
			right: -2
		},
		basketBadgeMobile: {
			width: 'auto'
		},
		headerPopper: {
			width: 'auto !important',
			minWidth: 110
		},
		headerPopperContent: {
			textAlign: 'center',
			color: 'white',
			fontSize: 12
		}
	};
});
